import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter} from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Content } from "../../../components/Content";
import { UserHeader } from "./UserHeader";
import { UserAddresses } from "./UserAddresses";
import { UserCompanies } from "./UserCompanies";
import { UserPropertiesEditor } from "./UserPropertiesEditor";

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class BasicDetailsComp extends BaseComponent {
    constructor(props) {
        super(props, {});
    }

    get user() {
        return this.props.user;
    }

    render() {
        return (
            <Container>
                <h3>{this.user.name}</h3>
                <Content className="content">
                    <HBox>
                        <UserHeader user={this.user} />
                    </HBox>

                    <hr />
                    <HBox>
                        <UserAddresses user={this.user} />
                    </HBox>

                    <hr />
                    <HBox>
                        <UserCompanies user={this.user} />
                    </HBox>

                    <hr />
                    <HBox>
                        <UserPropertiesEditor user={this.user} />
                    </HBox>
                </Content>
            </Container>
        );
    }
}


BasicDetailsComp.propTypes = {
    dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
    createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
    return {
        dispatch,
    };
}

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps,
);

export const BasicDetails = compose(
    withConnect,
    withRouter,
)(BasicDetailsComp);
